<p-listbox [(ngModel)]="selectedItems" [options]="items"
           [multiple]="true" [checkbox]="true" [showToggleAll]="false" [highlightOnSelect]="false" [disabled]="isReadOnly"
           optionLabel="name" dataKey="id"
           (onChange)="onSelectionChange()" />
